import _regeneratorRuntime from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _styled from "styled-components";
import u from "updeep";
import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { ReactComponent as SuccessIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/success.svg";
import { ReactComponent as DeleteIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/bin-2.svg";
import { useDeviceData } from "../DeviceData/useDeviceData";
import { useDeviceApi } from "../DeviceData/useDeviceApi";
import { Header } from "../Header/Header";
import { timeToAngle, angleToTime, normalizeRanges } from "../ScheduleCircle/utils";
import { ScheduleSlider } from "../ScheduleCircle/ScheduleSlider/ScheduleSlider";
import { usePathCreator } from "../Config/useLinkCreator";
import { RangeEdge } from "../ScheduleCircle/ScheduleSlider/constants";
var weekDayNames = ["понедельник", "вторник", "среду", "четверг", "пятницу", "субботу", "воскресенье"];

var withLeadingZero = function withLeadingZero(num) {
  return num < 10 ? "0".concat(num) : "".concat(num);
};

function formatTime(time) {
  var hours = Math.floor(time / 60);
  var minutes = time % 60;
  return "".concat(hours, ":").concat(withLeadingZero(minutes));
}

var Container = _styled.div.withConfig({
  displayName: "ScheduleDayPage__Container",
  componentId: "sc-14voj7s-0"
})(["display:flex;flex-direction:column;"]);

var Title = _styled.div.withConfig({
  displayName: "ScheduleDayPage__Title",
  componentId: "sc-14voj7s-1"
})(["font-size:24px;margin-top:60px;text-align:center;"]);

var ScheduleSliderContainer = _styled.div.withConfig({
  displayName: "ScheduleDayPage__ScheduleSliderContainer",
  componentId: "sc-14voj7s-2"
})(["position:relative;display:flex;justify-content:center;margin:48px auto;width:368px;@media screen and (max-width:419px){margin-top:32px;margin-bottom:32px;width:288px;}"]);

var CircleElement = _styled.div.withConfig({
  displayName: "ScheduleDayPage__CircleElement",
  componentId: "sc-14voj7s-3"
})(["position:absolute;height:310px;width:310px;top:50%;left:50%;transform:translate(-50%,-50%);background-color:", ";border-radius:50%;display:flex;justify-content:center;align-items:center;color:white;font-size:48px;svg{width:120px;height:120px;display:block;fill:white;}@media screen and (max-width:419px){height:230px;width:230px;svg{width:80px;height:80px;}}"], function (p) {
  return p.removing ? "#dd4e4e" : "#4d9adf";
});

var ClockLabel = _styled.div.withConfig({
  displayName: "ScheduleDayPage__ClockLabel",
  componentId: "sc-14voj7s-4"
})(["position:absolute;font-size:20px;@media screen and (max-width:419px){font-size:16px;}"]);

var TopLabel = _styled(ClockLabel).withConfig({
  displayName: "ScheduleDayPage__TopLabel",
  componentId: "sc-14voj7s-5"
})(["bottom:100%;left:50%;transform:translateX(-50%);"]);

var BottomLabel = _styled(ClockLabel).withConfig({
  displayName: "ScheduleDayPage__BottomLabel",
  componentId: "sc-14voj7s-6"
})(["top:100%;left:50%;transform:translateX(-50%);"]);

var LeftLabel = _styled(ClockLabel).withConfig({
  displayName: "ScheduleDayPage__LeftLabel",
  componentId: "sc-14voj7s-7"
})(["right:100%;top:50%;transform:translateY(-50%);"]);

var RightLabel = _styled(ClockLabel).withConfig({
  displayName: "ScheduleDayPage__RightLabel",
  componentId: "sc-14voj7s-8"
})(["left:100%;top:50%;transform:translateY(-50%);"]);

var RangeList = _styled.div.withConfig({
  displayName: "ScheduleDayPage__RangeList",
  componentId: "sc-14voj7s-9"
})(["display:flex;flex-direction:column;align-items:center;font-size:24px;"]);

var Range = _styled.div.withConfig({
  displayName: "ScheduleDayPage__Range",
  componentId: "sc-14voj7s-10"
})(["font-size:22px;"]);

var RangeTime = _styled.div.withConfig({
  displayName: "ScheduleDayPage__RangeTime",
  componentId: "sc-14voj7s-11"
})(["display:inline-block;width:100px;text-align:", ";"], function (props) {
  return props.align || "left";
});

export function ScheduleDayPage() {
  var history = useHistory();

  var _useParams = useParams(),
      dayOfWeek = _useParams.dayOfWeek;

  var _useDeviceData = useDeviceData(),
      heatConfig = _useDeviceData.heatConfig;

  var _useDeviceApi = useDeviceApi(),
      setDaySchedule = _useDeviceApi.setDaySchedule;

  var pathCreator = usePathCreator();

  var _useState = useState(function () {
    return heatConfig.heatSchedule[dayOfWeek].map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          timeFrom = _ref2[0],
          timeTo = _ref2[1];

      return {
        from: timeToAngle(timeFrom),
        to: timeToAngle(timeTo),
        outOfBound: false
      };
    });
  }),
      _useState2 = _slicedToArray(_useState, 2),
      ranges = _useState2[0],
      setRanges = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      handlerTime = _useState4[0],
      setHandlerTime = _useState4[1];

  var backPath = pathCreator("/schedule");
  var removing = ranges.some(function (range) {
    return range.outOfBound;
  });

  var handleSave = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return setDaySchedule({
                variables: {
                  input: {
                    dayOfWeek: +dayOfWeek,
                    schedule: ranges.map(function (_ref4) {
                      var from = _ref4.from,
                          to = _ref4.to;
                      return [angleToTime(from), angleToTime(to)];
                    })
                  }
                }
              });

            case 2:
              history.push(backPath);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSave() {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Header, {
    backTo: backPath,
    actionIcon: SuccessIcon,
    onAction: handleSave
  }), /*#__PURE__*/React.createElement(Title, null, "\u0413\u0440\u0430\u0444\u0438\u043A \u0440\u0430\u0431\u043E\u0442\u044B", /*#__PURE__*/React.createElement("br", null), "\u043D\u0430 ", weekDayNames[dayOfWeek]), /*#__PURE__*/React.createElement(ScheduleSliderContainer, null, /*#__PURE__*/React.createElement(RightLabel, null, "6"), /*#__PURE__*/React.createElement(BottomLabel, null, "12"), /*#__PURE__*/React.createElement(LeftLabel, null, "18"), /*#__PURE__*/React.createElement(TopLabel, null, "24"), /*#__PURE__*/React.createElement(CircleElement, {
    removing: removing
  }, handlerTime !== null && !removing && formatTime(handlerTime), removing && /*#__PURE__*/React.createElement(DeleteIcon, null)), /*#__PURE__*/React.createElement(ScheduleSlider, {
    ranges: ranges,
    setRanges: setRanges,
    setHandlerTime: setHandlerTime
  })), /*#__PURE__*/React.createElement(RangeList, null, ranges.map(function (range, index) {
    return /*#__PURE__*/React.createElement(Range, {
      key: index
    }, /*#__PURE__*/React.createElement(RangeTime, {
      align: "right"
    }, formatTime(angleToTime(range.from))), " - ", /*#__PURE__*/React.createElement(RangeTime, {
      align: "left"
    }, formatTime(angleToTime(range.to))));
  })));
}